import angular from 'angular';

/**
 * @ngdoc overview
 * @name adminModule.rolesServices
 * @description
 * # adminModule.rolesServices
 * Module for managing the services of: roles. For $http requests, API calls.
 */
const rolesServices = angular.module('superuserModule.rolesServices', []);

/**
 * @ngdoc interface
 * @name adminModule.rolesServices.interface:Role
 * @description
 * Service for handling API connections for: Roles
 */
rolesServices.factory('Role', ['$http', 'AppsoupAPI', ($http, AppsoupAPI) => {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/role/`;

    return {
        getList: (params) => {
            const tableParams = AppsoupAPI.getTableParams(params);

            return $http.get(API_URL, {params: tableParams})
                .then((response) => {
                    return response.data.roles.data;
                });
        },
        get: (roleId) => {
            return $http.get(`${API_URL}${roleId}`);
        },
        save: (role, editMode) => {
            if (editMode) {
                return $http.put(`${API_URL}${role.id}`, role).then((response) => response.data);
            } else {
                return $http.post(API_URL, role).then((response) => response.data);
            }
        },
        remove: (roleId) => {
            return $http.delete(`${API_URL}${roleId}`).then((response) => response.data);
        },
        getShopIds: () => {
            return $http.get(`${AppsoupAPI.API_URL}/app/coupon/shops/allForRole`);
        }
    };
}]);

export default rolesServices;
